'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dAbstract$002dRandom$002dAccess$002dList$002dIterator from "./java.util.-Abstract-Random-Access-List-Iterator.js";
var $p;
/** @constructor */
function $c_ju_RandomAccessListIterator(list, i, start, end) {
  this.hJ = 0;
  this.s8 = 0;
  this.iP = 0;
  this.zV = null;
  this.zV = list;
  $j_java$002eutil$002e$002dAbstract$002dRandom$002dAccess$002dList$002dIterator.$ct_ju_AbstractRandomAccessListIterator__I__I__I__(this, i, start, end);
}
export { $c_ju_RandomAccessListIterator as $c_ju_RandomAccessListIterator };
$p = $c_ju_RandomAccessListIterator.prototype = new $j_java$002eutil$002e$002dAbstract$002dRandom$002dAccess$002dList$002dIterator.$h_ju_AbstractRandomAccessListIterator();
$p.constructor = $c_ju_RandomAccessListIterator;
/** @constructor */
function $h_ju_RandomAccessListIterator() {
}
export { $h_ju_RandomAccessListIterator as $h_ju_RandomAccessListIterator };
$h_ju_RandomAccessListIterator.prototype = $p;
$p.fS = (function(index) {
  return this.zV.fS(index);
});
$p.WR = (function(index) {
  this.zV.us(index);
});
var $d_ju_RandomAccessListIterator = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_RandomAccessListIterator, "java.util.RandomAccessListIterator", ({
  ni: 1,
  mP: 1,
  dS: 1,
  bd: 1,
  nj: 1
}));
export { $d_ju_RandomAccessListIterator as $d_ju_RandomAccessListIterator };
